import { Pago } from "../../bussines/entities/Pago";
import { EstadoPago } from "../../utils/types/EstadoPago";
import { TipoPago } from "../../utils/types/TipoPago";

export class PagoModel implements Pago {
    constructor(
        public idPago: number,
        public idCliente: number,
        public nombreRazonSocialCliente: string,
        public tipoDocIdentidadCliente: string,
        public docIdentidadCliente: string,
        public documento: string,
        public idSuscripcion: number | null,
        public monto: number,
        public codMoneda: string,
        public fechaPago: Date,
        public fechaCobro: Date | null,
        public estadoPago: EstadoPago,
        public montoCuponDescuento: number | null,
        public fechaPeriodoDesde: Date | null,
        public fechaPeriodoHasta: Date | null,
        public tipoPago: TipoPago
    ) { }

    serialize(): Pago {
        return {
            idPago: this.idPago,
            idCliente: this.idCliente,
            nombreRazonSocialCliente: this.nombreRazonSocialCliente,
            tipoDocIdentidadCliente: this.tipoDocIdentidadCliente,
            docIdentidadCliente: this.docIdentidadCliente,
            documento: this.documento,
            idSuscripcion: this.idSuscripcion,
            monto: this.monto,
            codMoneda: this.codMoneda,
            fechaPago: this.fechaPago,
            fechaCobro: this.fechaCobro,
            estadoPago: this.estadoPago,
            montoCuponDescuento: this.montoCuponDescuento,
            fechaPeriodoDesde: this.fechaPeriodoDesde,
            fechaPeriodoHasta: this.fechaPeriodoHasta,
            tipoPago:this.tipoPago
        }
    }

    static deserialize(entity: Pago): PagoModel {
        return new PagoModel(
            entity.idPago,
            entity.idCliente,
            entity.nombreRazonSocialCliente,
            entity.tipoDocIdentidadCliente,
            entity.docIdentidadCliente,
            entity.documento,
            entity.idSuscripcion,
            entity.monto,
            entity.codMoneda,
            entity.fechaPago,
            entity.fechaCobro,
            entity.estadoPago,
            entity.montoCuponDescuento,
            entity.fechaPeriodoDesde ?? null,
            entity.fechaPeriodoHasta ?? null,
            entity.tipoPago
        )
    }
}